<style lang="less">
.app-header-message-vue {
  float: left;
  margin-right: 15px;
  .h-dropdowncustom-show {
    height: @layout-header-height;
    .app-header-icon-item {
      margin-right: 0;
    }
    &.h-pop-trigger {
      background: @hover-background-color;
    }
  }
}
.app-message-dropdown-dropdown-container {
  width: 360px;
  min-height: 240px;
  .todo-tabs {
    display: flex;
    border-bottom: 1px solid #eef1f5;
    .todo-tab {
      flex: 1;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 13px;
      color: #6b7280;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      user-select: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      i {
        font-size: 14px;
        line-height: 1;
      }
      &:hover {
        color: @primary-color;
      }
      &.is-active {
        color: @primary-color;
        border-bottom-color: @primary-color;
        font-weight: 600;
      }
    }
  }
  .todo-add-bar {
    display: flex;
    gap: 8px;
    padding: 10px 14px;
    border-bottom: 1px solid #eef1f5;
    .todo-input {
      flex: 1;
      height: 32px;
      padding: 0 10px;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      outline: none;
      font-size: 13px;
      &:focus {
        border-color: @primary-color;
      }
    }
  }
  .message-list-container {
    max-height: 360px;
    overflow: auto;
    .todo-empty {
      padding: 36px 16px;
      text-align: center;
      color: @gray-color;
      font-size: 13px;
    }
    .common-list-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 10px 14px;
      border-bottom: 1px solid #f3f4f6;
      &:hover {
        background: @hover-background-color;
      }
      .todo-main {
        flex: 1;
        min-width: 0;
      }
      .description {
        margin: 4px 0 0;
        font-size: 12px;
        color: @gray-color;
        word-break: break-word;
      }
      .title {
        position: relative;
        margin: 0;
        font-size: 13px;
        line-height: 1.4;
        word-break: break-word;
      }
      .todo-actions {
        display: flex;
        flex-shrink: 0;
        gap: 4px;
        opacity: 0.75;
        .todo-action-btn {
          width: 28px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border: none;
          border-radius: 6px;
          background: transparent;
          color: #6b7280;
          cursor: pointer;
          padding: 0;
          &:hover {
            background: #eef2f7;
            color: @primary-color;
          }
          &.is-danger:hover {
            color: @red-color;
            background: #fef2f2;
          }
          &.todo-text-btn {
            width: auto;
            min-width: 36px;
            padding: 0 8px;
            font-size: 12px;
          }
          &.is-confirm {
            color: @red-color;
            font-weight: 600;
            &:hover {
              color: @red-color;
              background: #fef2f2;
            }
          }
        }
        .todo-confirm-hint {
          align-self: center;
          font-size: 12px;
          color: #9ca3af;
          white-space: nowrap;
        }
      }
      &.is-done .title {
        color: @gray-color;
        text-decoration: line-through;
      }
      &.is-done .todo-action-btn.is-done-btn {
        color: #16a34a;
      }
      &.is-pending .title:before {
        content: '';
        position: absolute;
        width: 5px;
        height: 5px;
        background: @red-color;
        border-radius: 5px;
        left: -10px;
        top: 5px;
      }
      &.is-pending .title {
        padding-left: 2px;
        margin-left: 8px;
      }
    }
  }
}
</style>
<template>
  <DropdownCustom class="app-header-message-vue" placement="bottom-end" className="app-message-dropdown" :toggleIcon="false" ref="messageDropdown">
    <div class="app-header-icon-item">
      <Badge :count="pendingCount">
        <i class="h-icon-bell"></i>
      </Badge>
    </div>
    <template v-slot:content>
      <div class="h-panel" @click.stop>
        <div class="todo-tabs">
          <div
            v-for="tab of tabs"
            :key="tab.key"
            class="todo-tab"
            :class="{ 'is-active': activeTab === tab.key }"
            @click="activeTab = tab.key"
          >
            <i :class="tab.icon"></i>
            <span>{{ tab.label }}{{ tabCount(tab.key) ? ` (${tabCount(tab.key)})` : '' }}</span>
          </div>
        </div>
        <div v-if="activeTab === 'pending'" class="todo-add-bar">
          <input
            v-model="newTitle"
            class="todo-input"
            type="text"
            maxlength="100"
            placeholder="输入任务后回车添加"
            @keydown.enter.prevent="addTodo"
          />
          <Button size="s" color="primary" :loading="adding" @click="addTodo">添加</Button>
        </div>
        <div class="message-list-container common-list-container">
          <div v-if="!filteredList.length" class="todo-empty">{{ emptyText }}</div>
          <div
            class="common-list-item"
            v-for="m of filteredList"
            :key="m.id"
            :class="{
              'is-done': m.isDone && !m.isDeleted,
              'is-pending': !m.isDone && !m.isDeleted
            }"
          >
            <div class="todo-main">
              <p class="title">{{ m.title }}</p>
              <p v-if="m.description" class="description">{{ m.description }}</p>
            </div>
            <div class="todo-actions">
              <template v-if="confirmId === m.id">
                <span class="todo-confirm-hint">{{ confirmHint }}</span>
                <button type="button" class="todo-action-btn is-danger todo-text-btn is-confirm" @click="confirmAction(m)">
                  确认
                </button>
                <button type="button" class="todo-action-btn todo-text-btn" @click="cancelConfirm">取消</button>
              </template>
              <template v-else-if="!m.isDeleted">
                <button
                  type="button"
                  class="todo-action-btn is-done-btn"
                  :title="m.isDone ? '标为未完成' : '完成'"
                  @click="toggleDone(m)"
                >
                  <i class="icon-check"></i>
                </button>
                <button type="button" class="todo-action-btn is-danger" title="删除" @click="askMoveToTrash(m)">
                  <i class="icon-trash"></i>
                </button>
              </template>
              <template v-else>
                <button type="button" class="todo-action-btn todo-text-btn" title="恢复" @click="restoreTodo(m)">
                  恢复
                </button>
                <button type="button" class="todo-action-btn is-danger todo-text-btn" title="彻底删除" @click="askPurge(m)">
                  清除
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
  </DropdownCustom>
</template>
<script>
import Request from '@common/request';
import { message } from 'heyui';

export default {
  data() {
    return {
      todoList: [],
      newTitle: '',
      adding: false,
      activeTab: 'pending',
      confirmId: null,
      confirmType: '',
      tabs: [
        { key: 'pending', label: '待办中', icon: 'icon-clock' },
        { key: 'done', label: '已完成', icon: 'icon-check' },
        { key: 'deleted', label: '已删除', icon: 'icon-trash' }
      ]
    };
  },
  computed: {
    confirmHint() {
      return this.confirmType === 'purge' ? '彻底删除？' : '移到回收站？';
    },
    pendingCount() {
      return this.todoList.filter((item) => !item.isDone && !item.isDeleted).length;
    },
    filteredList() {
      if (this.activeTab === 'done') {
        return this.todoList.filter((item) => item.isDone && !item.isDeleted);
      }
      if (this.activeTab === 'deleted') {
        return this.todoList.filter((item) => item.isDeleted);
      }
      return this.todoList.filter((item) => !item.isDone && !item.isDeleted);
    },
    emptyText() {
      if (this.activeTab === 'done') return '暂无已完成任务';
      if (this.activeTab === 'deleted') return '回收站为空';
      return '暂无待办，添加一个任务吧';
    }
  },
  watch: {
    pendingCount(val) {
      this.$store.dispatch('updateMsgCount', { messages: val });
    },
    activeTab() {
      this.cancelConfirm();
    }
  },
  mounted() {
    this.loadTodos();
  },
  methods: {
    tabCount(key) {
      if (key === 'done') return this.todoList.filter((item) => item.isDone && !item.isDeleted).length;
      if (key === 'deleted') return this.todoList.filter((item) => item.isDeleted).length;
      return this.todoList.filter((item) => !item.isDone && !item.isDeleted).length;
    },
    normalizeItem(item) {
      const done = !!(item.isDone ?? item.isReaded);
      return {
        id: item.id,
        title: item.title || '',
        description: item.description || '',
        isDone: done,
        isReaded: done,
        isDeleted: !!item.isDeleted
      };
    },
    upsertItem(item) {
      const normalized = this.normalizeItem(item);
      const idx = this.todoList.findIndex((t) => t.id === normalized.id);
      if (idx >= 0) {
        this.todoList.splice(idx, 1, normalized);
      } else {
        this.todoList.unshift(normalized);
      }
      this.syncBadge();
    },
    syncBadge() {
      this.$store.dispatch('updateMsgCount', { messages: this.pendingCount });
    },
    cancelConfirm() {
      this.confirmId = null;
      this.confirmType = '';
    },
    askMoveToTrash(item) {
      this.confirmId = item.id;
      this.confirmType = 'trash';
    },
    askPurge(item) {
      this.confirmId = item.id;
      this.confirmType = 'purge';
    },
    confirmAction(item) {
      if (this.confirmType === 'purge') {
        this.purgeTodo(item);
      } else {
        this.moveToTrash(item);
      }
    },
    async loadTodos() {
      const resp = await Request.Home.getMessageList();
      if (resp.ok) {
        const list = Array.isArray(resp.body) ? resp.body : [];
        this.todoList = list.map((item) => this.normalizeItem(item));
        this.syncBadge();
      }
    },
    async addTodo() {
      const title = (this.newTitle || '').trim();
      if (!title) {
        message.warn('请输入任务内容');
        return;
      }
      if (this.adding) return;
      this.adding = true;
      try {
        const resp = await Request.Home.createTodo({ title, description: '' });
        if (!resp.ok) {
          message.error(resp._msg || '添加失败');
          return;
        }
        this.upsertItem(resp.body);
        this.newTitle = '';
        this.activeTab = 'pending';
      } finally {
        this.adding = false;
      }
    },
    async toggleDone(item) {
      this.cancelConfirm();
      const nextDone = !item.isDone;
      const resp = await Request.Home.setTodoDone(item.id, nextDone);
      if (!resp.ok) {
        message.error(resp._msg || '更新失败');
        return;
      }
      this.upsertItem(resp.body || { ...item, isDone: nextDone });
    },
    async moveToTrash(item) {
      const resp = await Request.Home.deleteTodo(item.id);
      this.cancelConfirm();
      if (!resp.ok) {
        message.error(resp._msg || '删除失败');
        return;
      }
      this.upsertItem(resp.body || { ...item, isDeleted: true });
    },
    async restoreTodo(item) {
      this.cancelConfirm();
      const resp = await Request.Home.restoreTodo(item.id);
      if (!resp.ok) {
        message.error(resp._msg || '恢复失败');
        return;
      }
      const updated = this.normalizeItem(resp.body || { ...item, isDeleted: false });
      this.upsertItem(updated);
      this.activeTab = updated.isDone ? 'done' : 'pending';
    },
    async purgeTodo(item) {
      const resp = await Request.Home.purgeTodo(item.id);
      this.cancelConfirm();
      if (!resp.ok) {
        message.error(resp._msg || '彻底删除失败');
        return;
      }
      this.todoList = this.todoList.filter((t) => t.id !== item.id);
      this.syncBadge();
    }
  }
};
</script>
